export const secondsToMinutes = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const restSeconds = seconds % 60

  const formatMinutes = minutes.toString().padStart(2, '0')
  const formatSeconds = restSeconds.toString().padStart(2, '0')

  return `${formatMinutes}:${formatSeconds}`
}
